<template>
  <div class="auth">
    <div class="container">
      <loading :active.sync="isLoading" color="#4CAF50" :width=100 :height=100 :opacity=.7></loading>
      <div class="row">
        <div class="col-md-12">
          <form @submit.prevent="checkForm" action="#" method="post">
            <h3>Авторизация</h3>
            <input type="text" placeholder="Код промоутера" v-model="agentId" :disabled="isLoading">
            <input type="password" placeholder="Пароль" v-model="password" :disabled="isLoading">
            <input type="submit" :disabled="isLoading" value="Войти">
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $backend from '../backend'
import Loading from 'vue-loading-overlay'

export default {
  name: 'auth',
  data () {
    return {
      isLoading: false,
      resources: {},
      agentId: '',
      password: ''
    }
  },
  components: {
    Loading
  },
  created () {
    this.logout()
  },
  methods: {
    checkForm () {
      if (this.agentId === '' || this.password === '' || !/\d+$/.test(this.agentId)) {
        this.$swal({type: 'error', text: 'Укажите корректный код промоутера и пароль.'})
      } else {
        this.login()
      }
    },
    login () {
      this.isLoading = true
      $backend.login(this.agentId, this.password)
        .then(() => {
          this.$store.dispatch('login')
        })
        .then(() => {
          this.$router.push({name: 'firstStep'})
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    logout () {
      this.$store.dispatch('logout')
    }
  }
}
</script>
